export const navbar_links = [
  { text: "Servicios", i18n: "navbar.services", to: "/services" },
  { text: "FAQ", i18n: "navbar.faq", to: "/faq" },
  { text: "Blog", i18n: "navbar.blog", to: "/experience" },
  { text: "Contacto", i18n: "navbar.contact", to: "/contact" },
  { text: "Sobre CBX", i18n: "navbar.about", to: "/about" },
  //{ text: "CBX+", i18n: "navbar.cbxplus", to: "/" },
];
